import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Get from '../../api/internal/Get';
import BBITable from '../../helpers/bBITable/BBITable';
import DateOnlyUTCFormatter from '../../helpers/inputs/DateOnlyUTCFormatter';
import DateTimeUTCFormatter from '../../helpers/inputs/DateTimeUTCFormatter';
import Button from '../../assets/essentials/Button';
import Create from '../../helpers/modal/CreateModal';
import Modal from '../../helpers/modal/Modal';
import EditEvent from './EditEvent';
import Header from '../../layouts/Header';
import FilterData from '../../helpers/filter/FilterData';
import { MdOutlineRefresh } from 'react-icons/md';

type OutletContext = {
  filterValue: string;
};

const Events = () => {
  const [events, setEvents] = useState<DriverEvent[]>([]);
  const { filterValue } = useOutletContext<OutletContext>();

  console.log(events);

  useEffect(() => {
    GetEvents();
  }, []);

  function GetEvents() {
    Get('Schedule/GetDriverEvents').then(res => {
      if (res) {
        setEvents(res.data);
      }
    });
  }

  function formatData(events: DriverEvent[]) {
    return events.map(event => ({
      ...event,
      startDate: DateOnlyUTCFormatter(event.startDate),
      endDate: event.endDate ? DateOnlyUTCFormatter(event.endDate) : '',
      requestedDate: event.requestedDate
        ? DateOnlyUTCFormatter(event.requestedDate)
        : '',
      approvedDate: event.approvedDate
        ? DateOnlyUTCFormatter(event.approvedDate)
        : '',
      createdDate: DateTimeUTCFormatter(event.createdDate),
      modifiedDate: event.modifiedDate
        ? DateTimeUTCFormatter(event.modifiedDate)
        : '',
      isAllDay: event.isAllDay ? '✅' : '❌',
      actions: (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Button onClick={() => handleEdit(event)}>Edit</Button>
        </div>
      ),
    }));
  }

  const handleEdit = (event: DriverEvent) => {
    Create(
      <Modal>
        <EditEvent event={event} onSuccess={GetEvents} />
      </Modal>,
    );
  };

  const columnConfig = [
    {
      key: '1',
      attribute: 'driverName',
      attributeprimaryhidden: 'driverId',
      header: 'Driver',
    },
    {
      key: '2',
      attribute: 'eventTypeName',
      attributeprimaryhidden: 'eventTypeId',
      header: 'Event Type',
    },
    {
      key: '3',
      attribute: 'eventStatusName',
      attributeprimaryhidden: 'eventStatusId',
      header: 'Status',
    },
    {
      key: '4',
      attribute: 'startDate',
      header: 'Start Date',
    },
    {
      key: '5',
      attribute: 'endDate',
      header: 'End Date',
    },
    {
      key: '6',
      attribute: 'isAllDay',
      header: 'All Day',
    },
    {
      key: '7',
      attribute: 'notes',
      header: 'Notes',
    },
    {
      key: '8',
      attribute: 'requestedDate',
      header: 'Requested Date',
    },
    {
      key: '9',
      attribute: 'approvedDate',
      header: 'Approved Date',
    },
    {
      key: '10',
      attribute: 'approvedByEmployeeName',
      attributeprimaryhidden: 'approvedByEmployeeId',
      header: 'Approved By',
    },
    {
      key: '11',
      attribute: 'createdByEmployeeName',
      attributeprimaryhidden: 'createdByEmployeeId',
      header: 'Created By',
    },
    {
      key: '12',
      attribute: 'createdDate',
      header: 'Created Date',
    },
    {
      key: '13',
      attribute: 'modifiedByEmployeeName',
      attributeprimaryhidden: 'modifiedByEmployeeId',
      header: 'Modified By',
    },
    {
      key: '14',
      attribute: 'modifiedDate',
      header: 'Modified Date',
    },
    {
      key: '15',
      attribute: 'actions',
      header: 'Actions',
    },
  ];

  return (
    <>
      <h1>All Events</h1>
      <BBITable
        data={FilterData(formatData(events), filterValue)}
        columns={columnConfig}
      />
    </>
  );
};

export default Events;
